import * as policy from '../../../config/bite-attribution.json';
import { biteCampaignSearches, clearBiteAnalyticsEntry } from './bite-entry';

const KEY = 'bite_campaign';
type Touch = { at: number; values: Record<string, string> };
type Campaign = { first: Touch; last: Touch };

function campaignValues(search: string) {
  const params = new URLSearchParams(search);
  const values: Record<string, string> = {};
  for (const key of policy.campaignFields) {
    const value = params.get(key) || '';
    if (value && value.length <= policy.campaignMaxLength && /^[\p{L}\p{N} _.-]+$/u.test(value)) values[key] = value;
  }
  return values;
}

export function biteCampaign(): Campaign | null {
  try {
    const stored = JSON.parse(localStorage.getItem(KEY) || 'null') as Campaign | null;
    let next = stored?.first?.at && Date.now() - stored.first.at < policy.retentionMs ? stored : null;
    for (const search of biteCampaignSearches()) {
      const values = campaignValues(search);
      if (!values.utm_source || JSON.stringify(next?.last.values) === JSON.stringify(values)) continue;
      const touch = { at: Date.now(), values };
      next = { first: next?.first || touch, last: touch };
    }
    if (next) localStorage.setItem(KEY, JSON.stringify(next));
    return next;
  } catch { return null; }
}

export function clearBiteCampaign() { clearBiteAnalyticsEntry(); localStorage.removeItem(KEY); }
